import "./DashboardStyleSheet.css";
import { KpiDto } from "../../models/Dashboard";

const KpiStrip: React.FC<{ kpis: KpiDto[] }> = ({ kpis }) => (
    <div className="kpi-strip">
        {kpis.map(kpi => (
            <div key={kpi.id} className="kpi-card">
                <div className="kpi-label">{kpi.label}</div>
                <div className="kpi-value">{kpi.valueFormatted}</div>
                {kpi.deltaFormatted && (
                    <div className={`kpi-delta kpi-delta--${kpi.direction}`}>
                        {kpi.direction === "up" ? "▲" : kpi.direction === "down" ? "▼" : "—"}
                        {kpi.deltaFormatted}
                    </div>
                )}
            </div>
        ))}
    </div>
);
export default KpiStrip;